<h1 mat-dialog-title>Merge Tags</h1>
<div mat-dialog-content>
    <p>
        Merge the selected ({{ tags.length }}) tags into
        <strong>{{ tagList.selectedOptions.selected[0]?.value.displayName }}</strong>
    </p>
    <mat-selection-list #tagList [multiple]="false" [hideSingleSelectionIndicator]="true">
        @for (tag of tags; track tag) {
            <mat-list-option [value]="tag">
                <mat-icon matListItemIcon>label</mat-icon>
                <span matListItemTitle>{{ tag.displayName }}</span>
                <span matListItemLine>Used by {{ tag.count }} Assets</span>
            </mat-list-option>
        }
    </mat-selection-list>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button
        mat-stroked-button
        color="primary"
        [disabled]="tagList.selectedOptions.selected.length === 0"
        (click)="save()"
    >
        Save
    </button>
</div>
